import {Reporting as apis} from '@/api/system'

const listConfig = [
    {title: '举报类型', key: 'reporttype'},
    {title: '举报内容', key: 'reportcontent'},
    {title: '图片', key: 'images'},
    {title: '举报时间', key: 'reportdate'},
    {
        title: '处理状态', key: 'treatmentstate', showData: {
            1: '待处理',
            2: '已处理',
        }
    },
    {title: '处理时间', key: 'treatmentdate'},
]

const btnConfig = [
    {bg: '#19458C', title: '处 理', key: 'dispose', role: 'DISPOSE'},
]

export default function config() {
    return {
        listConfig,
        btnConfig,
        apis
    }
}
